<div [@challengeRedeem]="state()">
  @if (!challenge.locked) {
    <div
      class="challenge-card"
      theming
      themingGroup="dailychallenge"
      [themingAsset]="'box' + (challenge.finished ? '-completed' : '')"
      [themingOverride]="dailyChallenge?.assets">
      @if (challenge.isGeneric) {
        <div
          class="challenge-icon"
          theming
          themingGroup="dailychallenge"
          themingAsset="slot-icon"
          [themingOverride]="dailyChallenge?.assets"
          avoidMulticlick></div>
      } @else {
        <div
          class="challenge-icon gameLink"
          avoidMulticlick
          [style.background-image]="gameIcon"
          (safeClick)="goToGame(challenge.gameId)"></div>
      }

      <div class="card-body">
        <div class="card-header">
          <span class="card-title">{{ challengeText | uppercase }}</span>
          @if (challenge.minBet !== 0) {
            <span class="card-subtitle"
              >{{ 'home.live-ops.gamechallenges.min-stake-of' | translate }}
              {{ challenge.minBet | beautifyNumber: ('common.culture' | translate) }}</span
            >
          }
        </div>

        <div class="card-content">
          <div class="progress-bar">
            <slotcom-progress-bar
              [classes]="['c-progress-bar--green-black']"
              [currentProgress]="challenge.current"
              [totalProgress]="challenge.total"
              [completed]="challenge.finished ? challenge.finished : true">
              <span class="text percent">
                {{
                  challenge.current < challenge.total
                    ? (challenge.current | notRoundingBeautifyNumber: ('common.culture' | translate)) +
                      ' / ' +
                      (challenge.total | notRoundingBeautifyNumber: ('common.culture' | translate))
                    : ('home.live-ops.gamechallenges.completed-2' | translate)
                }}
              </span>
            </slotcom-progress-bar>
          </div>
          <div class="complete-section">
            @if (!challenge.finished) {
              @if (!challenge.isGeneric) {
                <slotcom-button
                  (safeClick)="goToGame(challenge.gameId)"
                  audioType="functionality"
                  class="c-button--pink card-button go-game-button">
                  {{ 'home.buttons.go' | translate | uppercase }}
                </slotcom-button>
              }
              <div class="complete-text">{{ 'common.complete-now' | translate }}:</div>
              <slotcom-button
                data-testid="slotcom-dailyChallenge-completeWithGems-button"
                (safeClick)="completeChallengeWithGems(challenge.gemsToComplete)"
                audioType="payment"
                class="c-button--pink card-button">
                <span class="gem-icon"></span>
                {{ challenge.gemsToComplete | beautifyNumber: ('common.culture' | translate) }}
              </slotcom-button>
            } @else {
              <slotcom-button
                data-testid="slotcom-dailyChallenge-collectReward-button"
                [isLoading]="loadingRedeemChallenge()"
                (safeClick)="redeemChallenge()"
                audioType="reward"
                class="c-button--pink card-button completed-button">
                {{ 'common.collect' | translate | uppercase }}</slotcom-button
              >
            }
          </div>

          <div class="rewards">
            @for (reward of rewards; track reward) {
              @if (reward.value > 0) {
                <div
                  #rewardEl
                  class="reward"
                  [attr.data-reward-key]="reward.key"
                  theming
                  themingGroup="dailychallenge"
                  [themingAsset]="'reward-challenge-box' + (!challenge.finished ? '-completed' : '')"
                  [themingOverride]="dailyChallenge?.assets">
                  <span
                    class="reward-icon"
                    [style.background-image]="reward.icon"></span>
                  @if (reward.key === 'prestigeReward' && streak?.current >= streak?.threshold) {
                    <span class="streak-icon"></span>

                    <span
                      class="reward-number"
                      [attr.data-testid]="'dailyChallenge-reward-' + reward.key">
                      {{
                        reward.value + (reward.value * streak.extraRewardPercentage) / 100
                          | beautifyNumber: ('common.culture' | translate)
                      }}
                    </span>
                  } @else {
                    <span
                      class="reward-number"
                      [attr.data-testid]="'dailyChallenge-reward-' + reward.key">
                      {{ reward.value | beautifyNumber: ('common.culture' | translate) }}
                    </span>
                  }
                </div>
              }
            }
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div
      class="challenge-card blocked-challenge-card"
      theming
      themingGroup="dailychallenge"
      themingAsset="box"
      [themingOverride]="dailyChallenge?.assets">
      <div class="blocked-icon"></div>
      <div class="blocked-text">
        {{ 'home.modals.blocked-challenge-card.text' | translate: { x: blockedChallenges } }}
      </div>
    </div>
  }
</div>
